import axios from 'axios';

export function postData(data) {
  return axios({
    method: 'post',
    url: `https://endpoints-staging.brew-systems.co.uk/api/submit/workshoppro/contact-us`,
    data
  })
}
